(() => {
  const searchEngine = 'shopify_native';
  const seenPredictiveResults = new Set();

  function sanitizeQuery(value) {
    const query = String(value || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    if (!query) return '';
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(query)) return '[redacted]';

    const digits = query.replace(/\D/g, '');
    if (digits.length >= 7 && /^[+()\d\s.-]+$/.test(query)) return '[redacted]';

    return query;
  }

  function markSearchSession() {
    try {
      sessionStorage.setItem('adore_search_used', '1');
    } catch (error) {
      // Search must remain usable when browser privacy settings disable storage.
    }
  }

  function emit(eventName, properties = {}) {
    const detail = { event: eventName, search_engine: searchEngine, ...properties };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('adore:search-event', { detail }));
    markSearchSession();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"]');
    if (!form) return;

    const query = sanitizeQuery(new FormData(form).get('q'));
    if (!query) return;

    emit('adore_search_submitted', {
      search_surface: form.closest('[data-search-page]') ? 'search_page' : 'header_search',
      search_query: query
    });
  });

  document.addEventListener('adore:predictive-rendered', (event) => {
    const query = sanitizeQuery(event.detail && event.detail.query);
    const resultCount = Number(event.detail && event.detail.resultCount) || 0;
    const resultKey = `${query}:${resultCount}`;
    if (!query || seenPredictiveResults.has(resultKey)) return;

    seenPredictiveResults.add(resultKey);
    emit('adore_predictive_results', {
      search_surface: 'predictive_search',
      search_query: query,
      search_result_count: resultCount
    });
  });

  document.addEventListener('click', (event) => {
    const predictiveProduct = event.target.closest('[data-predictive-product]');
    if (predictiveProduct) {
      const searchRoot = predictiveProduct.closest('[data-search-query]');
      emit('adore_search_result_selected', {
        search_surface: 'predictive_search',
        search_query: sanitizeQuery(searchRoot && searchRoot.dataset.searchQuery),
        search_item_id: predictiveProduct.dataset.itemId || '',
        search_item_title: predictiveProduct.dataset.itemTitle || '',
        search_item_position: Number(predictiveProduct.dataset.itemPosition) || null
      });
      return;
    }

    const viewAll = event.target.closest('[data-predictive-view-all]');
    if (viewAll) {
      const searchRoot = viewAll.closest('[data-search-query]');
      emit('adore_search_submitted', {
        search_surface: 'predictive_view_all',
        search_query: sanitizeQuery(searchRoot && searchRoot.dataset.searchQuery)
      });
      return;
    }

    const result = event.target.closest('[data-search-result]');
    if (!result || !event.target.closest('a')) return;

    const searchPage = result.closest('[data-search-page]');
    emit('adore_search_result_selected', {
      search_surface: 'search_results_page',
      search_query: sanitizeQuery(searchPage && searchPage.dataset.searchQuery),
      search_item_id: result.dataset.itemId || '',
      search_item_title: result.dataset.itemTitle || '',
      search_item_position: Number(result.dataset.itemPosition) || null,
      search_item_price: Number(result.dataset.itemPrice) || null
    });
  });

  function measureSearchPage() {
    const searchPage = document.querySelector('[data-search-page]');
    if (!searchPage || searchPage.dataset.searchPerformed !== 'true') return;

    const query = sanitizeQuery(searchPage.dataset.searchQuery);
    if (!query) return;

    const resultCount = Number(searchPage.dataset.searchResultCount) || 0;
    if (resultCount === 0) {
      emit('adore_search_no_results', {
        search_surface: 'search_results_page',
        search_query: query,
        search_result_count: 0
      });
      return;
    }

    markSearchSession();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureSearchPage, { once: true });
  } else {
    measureSearchPage();
  }
})();
